import React from 'react';
import { LoginCallback } from '@okta/okta-react';
import { Route, Routes } from 'react-router-dom';
import LoaderNew from './components/loader/LoaderNew';
import { RequiredAuth } from './components/auth/SecureRoute';
import SearchMain from './components/pages/SearchMain';
import LoadingProvider from './components/layout/search/LoadingProvider';
import ImageDataProvider from './providers/ImageDataProvider';
import ChangePassword from './components/account/ChangePassword';

const App = () => {
    return (
        <LoadingProvider>
            <LoaderNew alwaysActive={false} />
            <ImageDataProvider>
                <Routes>
                    <Route
                        path='/callback'
                        element={
                            <LoginCallback loadingElement={<LoaderNew alwaysActive={true} />} />
                        }
                    />
                    <Route path='/' element={<RequiredAuth />}>
                        <Route path='' element={<SearchMain />} />
                    </Route>
                    <Route path='/account/change-password' element={<RequiredAuth />}>
                        <Route path='' element={<ChangePassword />} />
                    </Route>
                </Routes>
            </ImageDataProvider>
        </LoadingProvider>
    );
};

export default App;
